<div class="min-h-screen w-full min-w-0 overflow-x-hidden bg-cloud-mist">
  <div class="tfr-page-shell py-6 max-w-3xl">

    <header class="mb-6 flex items-start justify-between gap-4">
      <div class="min-w-0">
        <h1 class="flex items-center gap-2 text-[22px] font-bold text-midnight-indigo">
          {{ isNew() ? 'Nuevo lead (manual)' : (lead()?.contactName || lead()?.venueName || 'Lead') }}
          @if (!isNew()) {
            <lucide-icon name="info" class="h-5 w-5 text-steel-gray" />
          }
        </h1>
        @if (lead()?.createdAt; as created) {
          <p class="mt-1 text-[12px] text-steel-gray">Creado el {{ formatDate(created) }}</p>
        }
      </div>
      <div class="flex shrink-0 flex-wrap gap-2">
        @if (!isNew()) {
          <button
            type="button"
            (click)="openDeleteConfirm()"
            class="rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-[12px] font-semibold text-red-700 hover:bg-red-100">
            Eliminar
          </button>
        }
        <button
          type="button"
          (click)="close()"
          class="rounded-xl border border-pale-gray bg-white px-4 py-2 text-[12px] font-semibold text-steel-gray hover:border-slate-300">
          Cerrar
        </button>
      </div>
    </header>

    @if (loading()) {
      <p class="text-[13px] text-steel-gray">Cargando&hellip;</p>
    } @else {
      @if (saveError(); as err) {
        <div class="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] text-red-800">
          {{ err }}
        </div>
      }

      @if (venueImportFeedback(); as vf) {
        <div class="mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-[12px] text-emerald-800">
          {{ vf }}
        </div>
      }

      @if (!isNew()) {
        <section class="mb-5 rounded-2xl border border-pale-gray bg-white p-5">
          <div class="flex items-center justify-between gap-3">
            <h2 class="text-[14px] font-semibold text-midnight-indigo">Locales ({{ venues().length }})</h2>
            <button
              type="button"
              (click)="openAddVenue()"
              class="inline-flex items-center gap-1.5 rounded-lg border border-pale-gray px-3 py-1.5 text-[12px] font-semibold text-action-blue hover:border-action-blue/40">
              <lucide-icon name="plus" [size]="14" />
              A&ntilde;adir local
            </button>
          </div>
          <ul class="mt-3 space-y-2">
            @for (v of venues(); track v.id) {
              <li class="rounded-xl border border-pale-gray bg-cloud-mist/40 px-3 py-2.5">
                <p class="text-[13px] font-semibold text-midnight-indigo">{{ v.venueName }}</p>
                <p class="text-[11px] text-steel-gray">{{ v.city }}{{ v.province ? (', ' + v.province) : '' }}</p>
                @if (v.mapsUrl) {
                  <a [href]="v.mapsUrl" target="_blank" rel="noopener"
                     class="mt-1 inline-block text-[11px] text-action-blue hover:underline">Ver en Maps</a>
                }
              </li>
            } @empty {
              <li class="text-[12px] text-steel-gray">Sin locales en subcolecci&oacute;n (datos legacy en ficha).</li>
            }
          </ul>
        </section>
      }

      <form [formGroup]="leadForm" (ngSubmit)="saveLead()" class="space-y-5">

        <!-- Agendar próxima acción -->
        <section class="rounded-2xl border border-pale-gray bg-white p-5">
          <h2 class="text-[14px] font-semibold text-midnight-indigo">Agendar Pr&oacute;xima Acci&oacute;n</h2>
          <div class="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Fecha</span>
              <input formControlName="nextActionAt" type="datetime-local"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1 sm:col-span-2">
              <span class="text-[11px] font-semibold text-steel-gray">Nota de seguimiento</span>
              <textarea formControlName="nextActionNote" rows="2"
                        placeholder="Llamar el jueves para seguimiento..."
                        class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]"></textarea>
            </label>
          </div>
        </section>

        <!-- Datos extendidos -->
        <section class="rounded-2xl border border-pale-gray bg-white p-5">
          <h2 class="text-[14px] font-semibold text-midnight-indigo">Datos Extendidos</h2>
          <dl class="mt-3 space-y-2 text-[13px]">
            <div class="flex justify-between gap-4 border-b border-pale-gray/80 py-2">
              <dt class="text-steel-gray">Responsable</dt>
              <dd class="font-medium text-midnight-indigo text-right">{{ leadForm.controls.contactName.value || '—' }}</dd>
            </div>
            <div class="flex justify-between gap-4 border-b border-pale-gray/80 py-2">
              <dt class="text-steel-gray">Tel&eacute;fono</dt>
              <dd class="font-medium text-midnight-indigo text-right">{{ leadForm.controls.phone.value || '—' }}</dd>
            </div>
            <div class="flex justify-between gap-4 border-b border-pale-gray/80 py-2">
              <dt class="text-steel-gray">Email</dt>
              <dd class="font-medium text-midnight-indigo text-right break-all">{{ leadForm.controls.email.value || '—' }}</dd>
            </div>
            <div class="flex justify-between gap-4 py-2">
              <dt class="text-steel-gray">&Uacute;ltimo cambio</dt>
              <dd class="font-medium text-midnight-indigo text-right">{{ formatDate(lead()?.updatedAt) }}</dd>
            </div>
          </dl>

          <div class="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            @if (isNew()) {
              <p class="sm:col-span-2 text-[12px] font-semibold text-steel-gray">Primer local</p>
            }
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Nombre local *</span>
              <input formControlName="venueName" type="text"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Ciudad *</span>
              <input formControlName="city" type="text"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Contacto</span>
              <input formControlName="contactName" type="text"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Tel&eacute;fono</span>
              <input formControlName="phone" type="tel"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1 sm:col-span-2">
              <span class="text-[11px] font-semibold text-steel-gray">Email</span>
              <input formControlName="email" type="email"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Etapa</span>
              <select formControlName="status" class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]">
                @for (s of CRM_LEAD_STATUSES; track s) {
                  <option [value]="s">{{ CRM_STATUS_LABELS[s] }}</option>
                }
              </select>
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Prioridad</span>
              <select formControlName="priority" class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]">
                <option value="A">A — Crítica</option>
                <option value="B">B — Alta</option>
                <option value="C">C — Media</option>
              </select>
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Tipo local</span>
              <select formControlName="venueType" class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]">
                @for (entry of CRM_VENUE_TYPE_LABELS | keyvalue; track entry.key) {
                  <option [value]="entry.key">{{ entry.value }}</option>
                }
              </select>
            </label>
            <label class="block space-y-1">
              <span class="text-[11px] font-semibold text-steel-gray">Fuente</span>
              <select formControlName="source" class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]">
                @for (entry of CRM_SOURCE_LABELS | keyvalue; track entry.key) {
                  <option [value]="entry.key">{{ entry.value }}</option>
                }
              </select>
            </label>
            <label class="block space-y-1 sm:col-span-2">
              <span class="text-[11px] font-semibold text-steel-gray">Google Maps</span>
              <input formControlName="mapsUrl" type="url"
                     class="w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            </label>
          </div>
        </section>

        <!-- Bloc de notas -->
        <section class="rounded-2xl border border-pale-gray bg-white p-5">
          <h2 class="text-[14px] font-semibold text-midnight-indigo">Bloc de Notas</h2>
          <p class="mt-1 text-[11px] text-steel-gray">Se guarda autom&aacute;ticamente al hacer clic fuera.</p>
          <textarea
            formControlName="notes"
            rows="5"
            (blur)="saveNotesOnBlur()"
            placeholder="Notas libres sobre el local, contacto, objeciones..."
            class="mt-3 w-full rounded-xl border border-pale-gray px-3 py-2 text-[13px]"></textarea>
        </section>

        <!-- Enlaces producto -->
        @if (!isNew()) {
          <section class="rounded-2xl border border-pale-gray bg-white p-5">
            <h2 class="text-[14px] font-semibold text-midnight-indigo">Acciones r&aacute;pidas</h2>
            <div class="mt-3 flex flex-wrap gap-2">
              <button
                type="button"
                (click)="copyRegistrationLink()"
                class="inline-flex items-center gap-1.5 rounded-lg border border-pale-gray px-3 py-2 text-[12px] font-semibold text-midnight-indigo hover:border-action-blue/40">
                <lucide-icon name="link" [size]="14" />
                Copiar enlace registro
              </button>
              @if (copyFeedback(); as msg) {
                <span class="self-center text-[11px] text-emerald-700">{{ msg }}</span>
              }
            </div>
            <details class="mt-4">
              <summary class="cursor-pointer text-[12px] font-semibold text-steel-gray">Enlaces al producto</summary>
              <div class="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
                <label class="block space-y-1">
                  <span class="text-[11px] text-steel-gray">ownerUid</span>
                  <input formControlName="ownerUid" type="text"
                         class="w-full rounded-lg border border-pale-gray px-3 py-2 text-[12px] font-mono" />
                </label>
                <label class="block space-y-1">
                  <span class="text-[11px] text-steel-gray">spaceId</span>
                  <input formControlName="spaceId" type="text"
                         class="w-full rounded-lg border border-pale-gray px-3 py-2 text-[12px] font-mono" />
                </label>
              </div>
            </details>
          </section>
        }

        <button
          type="submit"
          [disabled]="saving()"
          class="w-full rounded-xl bg-action-blue py-3 text-[14px] font-semibold text-white disabled:opacity-60 sm:w-auto sm:px-8">
          {{ saving() ? 'Guardando…' : (isNew() ? 'Crear lead' : 'Guardar cambios') }}
        </button>
      </form>

      @if (!isNew()) {
        <section class="mt-8 rounded-2xl border border-pale-gray bg-white p-5">
          <h2 class="text-[14px] font-semibold text-midnight-indigo">Historial de actividades</h2>
          <form [formGroup]="activityForm" (ngSubmit)="addActivity()" class="mt-3 flex flex-col gap-2 sm:flex-row">
            <select formControlName="type" class="rounded-xl border border-pale-gray px-3 py-2 text-[12px] sm:w-36">
              @for (entry of CRM_ACTIVITY_TYPE_LABELS | keyvalue; track entry.key) {
                <option [value]="entry.key">{{ entry.value }}</option>
              }
            </select>
            <input formControlName="body" type="text" placeholder="Qué pasó / resultado"
                   class="min-w-0 flex-1 rounded-xl border border-pale-gray px-3 py-2 text-[13px]" />
            <button type="submit" [disabled]="saving()"
                    class="rounded-xl border border-action-blue px-4 py-2 text-[12px] font-semibold text-action-blue disabled:opacity-60">
              Añadir
            </button>
          </form>
          <ul class="mt-4 space-y-3">
            @for (act of activities(); track act.id) {
              <li class="rounded-xl bg-cloud-mist/60 px-3 py-2">
                <p class="text-[10px] font-semibold uppercase tracking-wide text-steel-gray">
                  {{ CRM_ACTIVITY_TYPE_LABELS[act.type] }} · {{ formatTs(act.createdAt) }}
                </p>
                <p class="mt-0.5 text-[12px] text-midnight-indigo whitespace-pre-wrap">{{ act.body }}</p>
              </li>
            } @empty {
              <li class="text-[12px] text-steel-gray">Sin actividades aún.</li>
            }
          </ul>
        </section>
      }
    }
  </div>
</div>

<app-admin-crm-lead-onboarding-modal
  [open]="showAddVenue()"
  (cancelled)="closeAddVenue()"
  (manual)="onAddVenueManual()"
  (imported)="onAddVenueFromMaps($event)" />

<app-admin-crm-delete-lead-modal
  [open]="showDeleteConfirm()"
  [leadLabel]="leadDeleteLabel()"
  [deleting]="deleting()"
  (cancelled)="closeDeleteConfirm()"
  (confirmed)="confirmDeleteLead()" />
